import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result, } from "../../../../interfaces";
import { Find, FindById } from "../../../actorTyes";
import { Adapter } from "../../../../shared/adapter";
import { ActorTypesAdapter } from "../../../../adapter/actorTypes-adapter";

export const FETCH_DATA_ACTOR_TYPES_REQUEST = 'FETCH_DATA_ACTOR_TYPES_REQUEST';
export const FETCH_DATA_ACTOR_TYPES_SUCCESS = 'FETCH_DATA_ACTOR_TYPES_SUCCESS';
export const FETCH_DATA_ACTOR_TYPES_FAILURE = 'FETCH_DATA_ACTOR_TYPES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataActorTypesRequest = () => {
    return {
        type: FETCH_DATA_ACTOR_TYPES_REQUEST,
    };
};

const fetchDataActorTypesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_ACTOR_TYPES_SUCCESS,
        payload: data
    };
};

const fetchDataActorTypesFailure = (error: any) => {
    return {
        type: FETCH_DATA_ACTOR_TYPES_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataActorTypesRequest());
        try {
            const response = await Find('actorTypes', query, page, pageSize);

            dispatch(fetchDataActorTypesSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new ActorTypesAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataActorTypesFailure(error.message));
        }
    };
};

export const findActorById = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataActorTypesRequest());
        try {
            const response = await FindById(id);
            dispatch(fetchDataActorTypesSuccess(
                { 
                    values : Adapter.from([response]).to((value) => new ActorTypesAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataActorTypesFailure(error.message));
        }
    };
};
